/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as yup from "yup";
import { ERROR_FILE_TYPE, ERROR_IS_REQUIRED } from "./constants";
import { isJson, hasFiles } from "./helpers";

export const schemaCredsGcp = yup.object().shape({
  displayName: yup.string(),
  providerId: yup.string().required(),
  ownerId: yup.string().required(),
  gcpFile: yup
    .mixed()
    .test("file", ERROR_IS_REQUIRED, (value: FileList) => {
      return hasFiles(value ?? []);
    })
    .test("fileType", ERROR_FILE_TYPE, (value: FileList) => {
      return hasFiles(value ?? []) && isJson(value[0]);
    }),
});
